import React, {Component} from "react";
import ReactLoadingTop from "../../../components/ReactLoadingTop";
import NavBarKS from "../../../components/NavBarKS";
import StickButton from "../../../components/StickButton";
import {deepCopyObject, hasUserRight, showAxiosError} from "../../../helper/helper";
import {DocumentFrom, ExternalCustomerMainType, UserRightsEnum} from "../../../helper/enums";
import MediaViewer from "../../einvoice/MediaViewer";
import Select from "../../../local_node_modules/react-select";
import {showConnector, showPredefinedBtn24} from "../../../helper/permission";
import {Button, Card, CardBody, CardSubtitle, Col, Row, UncontrolledTooltip} from "reactstrap";
import ExternalCustomer from "../../voucher/component/ExternalCustomer";
import TouristInfo from "../../invoice/component/TouristInfo";
import ForeignCompanyInfo from "../../invoice/component/ForeignCompanyInfo";
import NoIdentifier from "../../invoice/component/NoIdentifier";
import Datetime from "react-datetime";
import moment from "moment";
import NumberFormat from "react-number-format";
import InformationPanel from "../../invoice/component/InformationPanel";
import NoteList from "../../voucher/component/NoteList";
import TotalList from "../../voucher/component/TotalList";
import {request} from "../../../helper/APIUtils";
import {onSwitchExtCustomer, whenInvoiceTypeChange} from "../../../helper/invoiceHelper";
import {Decimal} from "decimal.js";
import _ from "lodash";
import Swal from "sweetalert2";
import Alert from "react-s-alert";
import {isValidBelge} from "../../../common/componentValidation";
import {EntegratorConf, VirtualHost} from "../../../constants";
import cacheInstance from "../../../components/cache/Cache";
import {eb, predefinedButtonFilter, predefinedInvoiceTypes} from "../../invoice/PredefinedInvoiceTypes";
import BelgeLines from "./BelgeLines";
import {validateField} from "../../../common/validation";
import InvoiceType from "../../invoice/component/InvoiceType";


class CreateEditBelge extends Component{

    constructor(props) {
        super(props);
        this.state = {
            error: {},
            saveLoading: false,
            isFree: false,
            activeTab: "temelbilgiler",
            saveType: "saveClose",
            manual: false,
            approveAsDespatch: false,
            isGocIdaresi: false,
            periods: [],
            iade: false,
            totalCosts: 0,
            isUpdateScenario: false,
            filteredXslts: [],
            predefinedBelgeType:null,
            newPreDefined: null,
            showOrderManagerLineNum: false
        };

        this.initialization = this.initialization.bind(this);
        this.predefinedBelgeType = this.predefinedBelgeType.bind(this);
        this.checkLocationChange = this.checkLocationChange.bind(this);
        this.onClickSave = this.onClickSave.bind(this);
        this.getInitDocument = this.getInitDocument.bind(this);
        this.saveDocument = this.saveDocument.bind(this);
        this.sendIncorrectInvoice = this.sendIncorrectInvoice.bind(this);
        this.documentTypeListener = this.documentTypeListener.bind(this);
        this.isManual = this.isManual.bind(this);
        this.setExternalCustomer = this.setExternalCustomer.bind(this);
        this.setOdemeYapacakAlici = this.setOdemeYapacakAlici.bind(this);
        this.setExternalCustomer = this.setExternalCustomer.bind(this);
        this.setShowOrderManagerLineNum = this.setShowOrderManagerLineNum.bind(this);
        this.errorListener = this.errorListener.bind(this);
        this.onChangeValue = this.onChangeValue.bind(this);
        this.setMediaViewer = this.setMediaViewer.bind(this);
        this.renderPredefinedButtons = this.renderPredefinedButtons.bind(this);
        this.renderSinglePredefined = this.renderSinglePredefined.bind(this);
        this.validateClass = this.validateClass.bind(this);
        this.validateMessage = this.validateMessage.bind(this);
        this.getSourceUrn = this.getSourceUrn.bind(this);
        this.toggle = this.toggle.bind(this);
        this.setTouristInfo = this.setTouristInfo.bind(this);
        this.setDocExternalCustomer = this.setDocExternalCustomer.bind(this);
        this.setGocIdaresi = this.setGocIdaresi.bind(this);
        this.updateScenario = this.updateScenario.bind(this);
        this.getXSLT = this.getXSLT.bind(this);
        this.filterXSLTs = this.filterXSLTs.bind(this);
        this.approveAsDespatch = this.approveAsDespatch.bind(this);
        this.setTrdDocBelgeLines = this.setTrdDocBelgeLines.bind(this);
        this.setTrdDocBelgeNotes = this.setTrdDocBelgeNotes.bind(this);
        this.isKamu = this.isKamu.bind(this);
        this.changeKDV = this.changeKDV.bind(this);
        this.onIsFree = this.onIsFree.bind(this);
        this.checkUserRights = this.checkUserRights.bind(this);
        this.preventNull = this.preventNull.bind(this);
        this.validateField = this.validateField.bind(this);
        this.setTrdDocBelgeDespatchReferences = this.setTrdDocBelgeDespatchReferences.bind(this);
        this.setTrdDocIadeTable = this.setTrdDocIadeTable.bind(this);
        this.checkSaveButtonIsPassive = this.checkSaveButtonIsPassive.bind(this);
        this.onChangeCurrency = this.onChangeCurrency.bind(this);
        this.onChange = this.onChange.bind(this);
        this.fetchPredefinedInvoiceForUser = this.fetchPredefinedInvoiceForUser.bind(this);
        this.onChangeDateAndCurrency = this.onChangeDateAndCurrency.bind(this);
    }

    static calculateTotal(tData, isFree) {
        let data = deepCopyObject(tData);
        let trdDocBelgeLines = data.trdDocBelgeLines;
        let lineExtensionTotalAmount = new Decimal(0.00);
        let lineChargeTotalAmount = new Decimal(0.00);
        let allowanceTotalAmount = new Decimal(0.00);
        let toBeAddedTotalChargeAmount = new Decimal(0.00);
        for (let i = 0; i < trdDocBelgeLines.length; i++) {
            let trdDocBelgeLine = trdDocBelgeLines[i];
            let trdDocBelgeLineCharges = trdDocBelgeLine.trdDocBelgeLineCharges;
            lineExtensionTotalAmount = lineExtensionTotalAmount.add(new Decimal(new Decimal(trdDocBelgeLine.quantity).mul(new Decimal(trdDocBelgeLine.unitPrice)).toFixed(2)).toNumber());
            for (let j = 0; j < trdDocBelgeLineCharges.length; j++) {
                let trdDocBelgeLineCharge = trdDocBelgeLineCharges[j];
                if (!(data.documentTypeCode === "IHRACKAYITLI" && trdDocBelgeLineCharge.taxCode.code === "0015")){
                    if(trdDocBelgeLineCharge.taxCode.code === "0003" || trdDocBelgeLineCharge.taxCode.code === "0011"){
                        lineChargeTotalAmount = lineChargeTotalAmount.add((new Decimal((trdDocBelgeLineCharge.amount === "" ? 0 : (trdDocBelgeLineCharge.amount + trdDocBelgeLineCharge.nakitTeminatiAmount + trdDocBelgeLineCharge.avansMahsubuAmount).toFixed(2)))).mul(trdDocBelgeLineCharge.direction));
                    }else {
                        lineChargeTotalAmount = lineChargeTotalAmount.add((new Decimal(trdDocBelgeLineCharge.amount === "" ? 0 : trdDocBelgeLineCharge.amount.toFixed(2))).mul(trdDocBelgeLineCharge.direction));
                    }
                }

                if (trdDocBelgeLineCharge.taxCode.code === "0000" || trdDocBelgeLineCharge.taxCode.code === "2001" ||
                    trdDocBelgeLineCharge.taxCode.code === "2002" || trdDocBelgeLineCharge.taxCode.code === "2003" ||
                    trdDocBelgeLineCharge.taxCode.code === "2004" || trdDocBelgeLineCharge.taxCode.code === "2005")  {
                    allowanceTotalAmount = allowanceTotalAmount.add(new Decimal(trdDocBelgeLineCharge.amount === "" ? 0 : trdDocBelgeLineCharge.amount));
                } else if (trdDocBelgeLineCharge.taxCode.code === "0001" || trdDocBelgeLineCharge.taxCode.code === "3001"
                    || trdDocBelgeLineCharge.taxCode.code === "3002") {
                    allowanceTotalAmount = allowanceTotalAmount.sub(new Decimal(trdDocBelgeLineCharge.amount === "" ? 0 : trdDocBelgeLineCharge.amount));
                } else {
                    if (trdDocBelgeLineCharge.direction === 1) {
                        toBeAddedTotalChargeAmount = toBeAddedTotalChargeAmount.add(new Decimal(trdDocBelgeLineCharge.amount === "" ? 0 : trdDocBelgeLineCharge.amount.toFixed(2)));
                    } else {

                    }
                }
            }
        }
        if (isFree && data.profileId === "IHRACAT") {
            data.payableAmount = 0.00;
        } else {
            let contributionAmount = 0;
            let trdDocBelgeNotes = data['trdDocBelgeNotes'];

            if (contributionAmount) {
                data.allowanceTotalAmount = new Decimal(allowanceTotalAmount.add(new Decimal(contributionAmount)).toFixed(4)).toNumber();
                if (!data.isManual) {
                    if (new Decimal(contributionAmount).add(data.payableAmount).toFixed(2) !== new Decimal(data.taxInclusiveAmount).toFixed(2))
                        data.payableAmount = new Decimal(lineExtensionTotalAmount.add(lineChargeTotalAmount).sub(new Decimal(contributionAmount)).toFixed(2)).toNumber();
                }
            } else {
                data.allowanceTotalAmount = new Decimal(allowanceTotalAmount.toFixed(2)).toNumber();
                if (!data.isManual) {
                    data.payableAmount = new Decimal(lineExtensionTotalAmount.add(lineChargeTotalAmount).toFixed(2,Decimal.ROUND_UP)).toNumber();
                    if (data.profileId === "IHRACAT") {
                        let totalCarriageValueAmount = 0;
                        let totalInsuranceValueAmount = 0;
                        for (let i = 0; i < trdDocBelgeLines.length; i++) {
                            let deliveryDetail = trdDocBelgeLines[i]["trdDocBelgeLineDeliveryDetail"];

                            if (deliveryDetail && deliveryDetail["deliveryTerms"] === "CIF" && deliveryDetail["declaredForCarriageValueAmount"])
                                totalCarriageValueAmount = new Decimal(totalCarriageValueAmount).add(new Decimal(deliveryDetail["declaredForCarriageValueAmount"]).toFixed(2));

                            if (deliveryDetail && deliveryDetail["deliveryTerms"] === "CIF" && deliveryDetail["insuranceValueAmount"])
                                totalInsuranceValueAmount = new Decimal(totalInsuranceValueAmount).add(new Decimal(deliveryDetail["insuranceValueAmount"]).toFixed(2));
                        }
                        data.payableAmount = new Decimal(lineExtensionTotalAmount.add(lineChargeTotalAmount).add(totalCarriageValueAmount).add(totalInsuranceValueAmount).toFixed(2)).toNumber();
                    }
                }
            }
        }
        data.lineExtensionAmount = new Decimal(lineExtensionTotalAmount.toFixed(2)).toNumber();
        if (!data.isManual) {
            data.taxInclusiveAmount = new Decimal(lineExtensionTotalAmount.sub(allowanceTotalAmount).add(toBeAddedTotalChargeAmount).toFixed(2)).toNumber();
        }
        if (!data.isManual)
            data.taxExclusiveAmount = new Decimal(lineExtensionTotalAmount.sub(allowanceTotalAmount).toFixed(2)).toNumber();


        for(let i = 0 ; i < data.trdDocBelgeLines.length ; i++){
            if(data.trdDocBelgeLines[i].quantity === 1){
                for (let i = 0; i < data.trdDocBelgeLines.length; i++) {
                    data.trdDocBelgeLines[i].totalPrice = new Decimal((data.trdDocBelgeLines[i].unitPrice * data.trdDocBelgeLines[i].quantity).toFixed(2)).toNumber();
                    for (let j = 0; j < data.trdDocBelgeLines[i].trdDocBelgeLineCharges.length; j++){
                        if(data.trdDocBelgeLines[i].trdDocBelgeLineCharges[j].taxCode.code === "0003" || data.trdDocBelgeLines[i].trdDocBelgeLineCharges[j].taxCode.code === "0011"){
                            data.trdDocBelgeLines[i].totalPrice = new Decimal((data.trdDocBelgeLines[i].totalPrice +
                                ((data.trdDocBelgeLines[i].trdDocBelgeLineCharges[j].amount + data.trdDocBelgeLines[i].trdDocBelgeLineCharges[j].nakitTeminatiAmount + data.trdDocBelgeLines[i].trdDocBelgeLineCharges[j].avansMahsubuAmount) * data.trdDocBelgeLines[i].trdDocBelgeLineCharges[j].direction)).toFixed(2)).toNumber();
                        }else{
                            data.trdDocBelgeLines[i].totalPrice = new Decimal((data.trdDocBelgeLines[i].totalPrice +
                                (data.trdDocBelgeLines[i].trdDocBelgeLineCharges[j].amount * data.trdDocBelgeLines[i].trdDocBelgeLineCharges[j].direction)).toFixed(2)).toNumber();
                        }
                    }
                }
            }
        }
        return data;
    }

    componentDidMount() {
        this.initialization();
    }

    initialization(){
        this.checkUserRights();
        let self = this;
        let match = this.props.match;
        let params = {
            url: `/belgeTmp/edit/${match.params.recordId}`,
            method: "post",
            data: {
                profileId: "EBELGE"
            }
        };
        request(params)
            .then(response => {
                let data = response.data.trdDocBelge;
                if (!data.externalCustomer) {
                    data.externalCustomer = {
                        commerceChamber: null,
                        customer: null,
                        externalCustomerAddressList: [],
                        familyName: null,
                        formattedName: null,
                        givenName: null,
                        mersisNumber: null,
                        middleName: null,
                        recordId: null,
                        taxOffice: null,
                        title: null,
                        tradeRegistrationNumber: null,
                        vknTckn: null,
                        isForeignCustomer: false,
                    };
                }

                let approveAsDespatch = false;

                if (data.trdDocBelgeNotes.length >= 1) {
                    let notes = data.trdDocBelgeNotes;
                    let found = false;
                    for (let i = 0; i < notes.length; i++) {
                        if (notes[i].note === "İrsaliye yerine geçer.") {
                            found = true;
                            approveAsDespatch = true;
                            break;
                        }
                    }
                }
                let checkAddress = data.externalCustomer.externalCustomerAddressList.filter((f) => f.defaultAddress === true);
                if (checkAddress !== undefined && checkAddress !== null && checkAddress.length > 0){
                    data.externalCustomerAddress = checkAddress[0];
                }
                if (!data.externalCustomerAddress) {
                    data.externalCustomerAddress = {
                        buildingName: null,
                        buildingNo: null,
                        cityName: null,
                        citySubdivisionName: null,
                        countryName: null,
                        email: null,
                        fax: null,
                        postalAddressRegion: null,
                        postalAddressRoom: null,
                        postalZone: null,
                        postboxAlias: null,
                        recordId: null,
                        streetName: null,
                        telephone: null,
                        webSite: null
                    };
                }

                if (this.props.location.state && this.props.location.state.type) {
                    let {externalCustomer, externalCustomerAddress, belgeTypeInfo} = this.props.location.state.type;
                    data.profileId = belgeTypeInfo.profileId;
                    data.documentTypeCode = belgeTypeInfo.documentTypeCode;
                    data.invoiceTypeCode  = belgeTypeInfo.invoiceTypeCode;
                    data.accountingCost   = belgeTypeInfo.accountingCost;
                    if (belgeTypeInfo.retailCustomer) {
                        data.retailCustomer = belgeTypeInfo.retailCustomer;
                    }
                    if (externalCustomer && externalCustomerAddress) {
                        data.externalCustomer = externalCustomer;
                        data.externalCustomerAddress = externalCustomerAddress;
                    }
                    if (!!belgeTypeInfo.trdDocBelgeLines) {
                        data.trdDocBelgeLines = belgeTypeInfo.trdDocBelgeLines;
                    }
                    data = this.predefinedBelgeType(data, belgeTypeInfo);
                }
                self.setState({
                    data: data,
                    iade: data.documentTypeCode === "IADE",
                    initData: deepCopyObject(data),
                    userAliasList: response.data.userAliasList,
                    userAliases: response.data.userAliases,
                    xslts: response.data.xslts,
                    charges: response.data.charges,
                    unitCodes: response.data.unitCodes,
                    currencyCodes: response.data.currencyCodes,
                    profileIds: response.data.profileIds,
                    exemptions: response.data.exemptions,
                    countries: response.data.countries,
                    classificationTypes: response.data.classificationTypes,
                    packageTypeCodes: response.data.packageTypeCodes,
                    deliveryTermsCodes: response.data.deliveryTermsCodes,
                    transportMeansTypeCodes: response.data.transportMeansTypeCodes,
                    transportModeCodes: response.data.transportModeCodes,
                    saleTypes: response.data.saleTypes,
                    accountingCosts: response.data.accountingCosts,
                    paymentMeansCodes: response.data.paymentMeansCodes,
                    paymentChannelCodes: response.data.paymentChannelCodes,
                    cities: response.data.cities,
                    withholdingTypes: response.data.withholdingTypes,
                    approveAsDespatch,
                    suffix: (response.data.currencyCodes).find(x => x.shortCode === response.data.trdDocBelge.documentCurrencyCode).symbol,
                });
                this.setShowOrderManagerLineNum(data.externalCustomer.vknTckn);

                this.fetchPredefinedInvoiceForUser()
            })
            .catch(function (error) {
                showAxiosError(error);
            });
    }

    checkUserRights() {
        if ( (this.props.match.params.recordId === "0" && !hasUserRight([UserRightsEnum.besbinotuzbin.create], this.props.currentUser))
            || (this.props.match.params.recordId !== "0" && !hasUserRight([UserRightsEnum.besbinotuzbin.update], this.props.currentUser))){
            this.props.history.push("/");
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.checkLocationChange(prevProps);
    }

    checkLocationChange(prev){
        let self = this;
        const locationChanged = self.props.location !== prev.location;
        let data = self.state.data;
        if(locationChanged){
            this.initialization();
        }
    }

    predefinedBelgeType = (data, belgeTypeInfo) => {
        let oldBelgeTypeCode = data.documentTypeCode;
        data = whenInvoiceTypeChange(data, belgeTypeInfo);

        if ((oldBelgeTypeCode !== "IHRACKAYITLI" && belgeTypeInfo.documentTypeCode === "IHRACKAYITLI") ||
            (oldBelgeTypeCode === "IHRACKAYITLI" && belgeTypeInfo.documentTypeCode !== "IHRACKAYITLI")) {
            data = CreateEditBelge.calculateTotal(data, this.state.isFree);
        }
        return data;
    };

    onClickSave(e, type) {
        let self = this;
        e.preventDefault();
        this.setState({saveLoading: true, saveType: type});
        let data = deepCopyObject(self.state.data);
        if (type === "new") {
            let one = deepCopyObject(data);
            let compareTo = deepCopyObject(self.state.initData);
            if (!compareTo.sourceUrn) {
                one.sourceUrn = null;
            }
            if (!(_.isEqual(one, compareTo))) {
                Swal({
                    title: 'Onay',
                    text: 'Faturadaki değişiklikler kaydedilsin mi?',
                    showCancelButton: true,
                    confirmButtonText: 'Evet',
                    cancelButtonText: 'Hayır',
                    showCloseButton: true,
                    onClose: () => {
                        self.setState({saveLoading: false});
                    }
                }).then((result) => {
                    if (result.value) {
                        self.saveDocument(data, type);
                        Swal.close();
                    } else if (result.dismiss === Swal.DismissReason.cancel) {
                        Swal.close();
                        self.getInitDocument("Yeni oluşturuldu.");
                    }
                });
            } else {
                this.getInitDocument("Yeni oluşturuldu.");
            }
        } else if (type === "look") {
            this.showDocument();
        } else if (type === "save") {
            this.saveDocument(data, type);
        } else if (type === "saveClose") {
            this.saveDocument(data, type);
        }/* else if (type === "directSend") {
            this.saveDocument(data, type);
        } else if (type === "saveSend") {
            //Hatalı faturanın düzenlenmiş halini gönderiyoruz. keşke sendCorrectedInvoice yazaydın tatlım
            if (this.state.data.deletedAt)
                this.sendIncorrectInvoice();
            else
                this.setState({saveLoading: false});
        }*/ else {
            this.setState({saveLoading: false});
        }
    }

    getInitDocument(info) {
        let self = this;
        let match = self.props.match;
        let params = {
            url: `/belgeTmp/edit/-1`,
            method: "post",
            data: {
                profileId: "EBELGE"
            }
        };
        request(params)
            .then(response => {
                Alert.closeAll();
                Alert.success(info, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 2000
                });
                let data = response.data.trdDocBelge;
                self.setState({data: data, initData: deepCopyObject(data), saveLoading: false, manual: true});
            })
            .catch(function (error) {
                self.setState({saveLoading: false});
                showAxiosError(error);
            });
    }

    showDocument() {
        let self = this;
        let data = deepCopyObject(self.state.data);
        let result = isValidBelge(data, "Tmp", this.isKamu(), this.state.activeTab, this.state.innerActiveTab);
        let error = result.error;
        let valid = result.valid;
        let item = data;
        if (valid) {
            let params = {
                url: "/belgeTmp/showDocument",
                responseType: 'arraybuffer',
                method: 'post',
                data: data
            };
            self.setState({mediaModal: true, title: item.documentUuid});

            request(params)
                .then(response => {
                    let blob = new Blob([response.data], {type: response.headers["content-type"]});
                    let urlCreator = window.URL || window.webkitURL;
                    let url = urlCreator.createObjectURL(blob);
                    self.setState({url: url, saveLoading: false});
                })
                .catch(function (error) {
                    self.setState({saveLoading: false});
                    showAxiosError(error);
                });
        } else {
            Alert.error(result.errorMessage, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 8000
            });
            self.setState({
                error: error,
                saveLoading: false,
                activeTab: result.activeTab,
                hTabs: result.hTabs
            });
        }
    }

    preventNull(data) {
        let lines = deepCopyObject(data.trdDocBelgeLines);
        for (let i = 0; i < lines.length; i++) {
            let lineCharges = deepCopyObject(lines[i].trdDocBelgeLineCharges);
            for (let j = 0; j < lineCharges.length; j++) {
                if (lineCharges[j].percentage === null || lineCharges[j].percentage === undefined) {
                    lineCharges[j].percentage = new Decimal(0).toNumber();
                }
            }
        }
        data["trdDocBelgeLines"] = lines;
        return data;
    }

    saveDocument(data, type) {
        let result = isValidBelge(data, "Tmp", this.isKamu(), this.state.activeTab, this.state.innerActiveTab, this.state.isGocIdaresi);
        data = this.preventNull(data);
        let error = result.error;
        let valid = result.valid;
        let self = this;
        let match = self.props.match;
        if (valid) {
            if (!data["from"]) {
                data["from"] = DocumentFrom.PORTAL;
            }

            let params = {
                url: `/belgeTmp/save`,
                method: "post",
                data: data
            };
            self.setState({saveLoading: true});
            request(params)
                .then(response => {
                    let data = response.data;
                    self.setState({saveLoading: false, data: data, initData: deepCopyObject(data)});
                    if (type === "saveClose") {
                        self.props.history.push(`/belgeTmp`);
                    } else if (type === "new") {
                        self.getInitInvoice("Kaydedildi");
                    } else if (type === "directSend") {
                        if(data.documentId && (['GOC','SGK'].includes(data.documentId.substring(0,3)) || (showConnector(EntegratorConf.identifier)  && hasUserRight(UserRightsEnum.ekonnektor.send,this.props.currentUser)))){
                            self.setState({ documentId : data.documentId, item: data}, () => {
                                self.confirmSend(data);
                            });
                        } else {
                            self.handleSend(data);
                        }
                    }
                    if (type !== "new") {
                        Alert.closeAll();
                        Alert.success('Kaydedildi', {
                            position: 'top-right',
                            effect: 'stackslide',
                            timeout: 2000
                        });
                    }
                })
                .catch(function (error) {
                    self.setState({saveLoading: false});
                    showAxiosError(error);
                });
        } else {
            Alert.error(result.errorMessage, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 8000
            });
            self.setState({
                error: error,
                saveLoading: false,
                activeTab: result.activeTab,
                innerActiveTab: result.innerActiveTab
            });
        }
    }

    sendIncorrectInvoice() {
        let self = this;
        let item = self.state.data;
        let match = self.props.match;
        let result = isValidBelge(item, "Tmp", this.isKamu());
        let error = result.error;
        let valid = result.valid;
        if (valid) {
            let params = {
                url: `/belgeTmp/update`,
                method: 'post',
                data: item
            };

            self.setState({saveLoading: true});
            request(params)
                .then(function (response) {
                    if (self.state.data.profileId === "EARSIVFATURA") {
                        cacheInstance.delete("archive");
                        self.props.history.push(`/eAInvoice`);
                    }
                    else {
                        cacheInstance.delete("outbox");
                        self.props.history.push(`/eInvoiceOutbox`);
                    }

                    Alert.closeAll();
                    Alert.success("Düzenlenmiş fatura başarılı şekilde gönderildi.", {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 2000
                    });
                    self.setState({saveLoading: false});
                }).catch(function (error) {
                self.setState({saveLoading: false});
                showAxiosError(error);
            });
        } else {
            Alert.error(result.errorMessage, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 8000
            });
            self.setState({error: error, saveLoading: false});
        }
    }

    documentTypeListener(belgeTypeInfo) {
        let data = deepCopyObject(this.state.data);
        let oldBelgeTypeCode = deepCopyObject(data.documentTypeCode);
        data = whenInvoiceTypeChange(data, belgeTypeInfo);
        if ((oldBelgeTypeCode !== "IHRACKAYITLI" && belgeTypeInfo.documentTypeCode === "IHRACKAYITLI") ||
            (oldBelgeTypeCode === "IHRACKAYITLI" && belgeTypeInfo.documentTypeCode !== "IHRACKAYITLI")) {
            data = CreateEditBelge.calculateTotal(data, this.state.isFree);
        }
        let iade = belgeTypeInfo.documentTypeCode === "IADE";

        if(data.profileId !== "EARSIVFATURA"){
            data.retailCustomer = false;
        }
        this.setState({data, iade});
    }

    isManual(manual) {
        this.setState({manual});
    }

    setExternalCustomer(externalCustomer, externalCustomerAddress) {
        this.setShowOrderManagerLineNum(externalCustomer.vknTckn);
        let data = deepCopyObject(this.state.data);
        data["externalCustomer"] = externalCustomer;
        data["externalCustomerAddress"] = externalCustomerAddress;
        this.setState({data}, ()=>this.setOdemeYapacakAlici());
    }

    setShowOrderManagerLineNum(vkn){
        this.setState({showOrderManagerLineNum: ["7350019759", "4600001884", "8720013736"].includes(vkn)})
    }

    async setExternalCustomerAsync(externalCustomer, externalCustomerAddress) {
        this.setShowOrderManagerLineNum(externalCustomer.vknTckn);
        let data = deepCopyObject(this.state.data);
        data["externalCustomer"] = externalCustomer;
        data["externalCustomerAddress"] = externalCustomerAddress;
        this.setState({data} , () => {return "ok";});
        //donot check gib
    }

    setOdemeYapacakAlici(){
        let self = this;
        let data = deepCopyObject(this.state.data);
        if(self.isKamu()) {
            data["paymentFormattedName"] = data["externalCustomer"].formattedName;
            data["paymentVkn"]  = data["externalCustomer"].vknTckn;
            data["paymentCity"] = data["externalCustomerAddress"].cityName;
            data["paymentCountry"] = data["externalCustomerAddress"].countryName;
            Alert.info("Ödeme Yapacak Alıcı bilgileri cari bilgilerinden kopyalanmıştır. Lütfen kontrol ediniz.", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000
            });
            self.setState({data},()=>self.isManual(true));
        }
    }

    errorListener(tError) {
        let error = this.state.error;
        error = Object.assign(error, tError);
        this.setState({error});
    }

    setPredefinedType(predefined,clearExtCustomer) {
        console.log("predefined",predefined);
        /*if (_.isEqual(predefined, this.state.predefinedInvoiceType)) {
            return;
        }*/
        let self = this;
        let data = deepCopyObject(self.state.data);
        if(clearExtCustomer){
            data = onSwitchExtCustomer(data,predefined.invoiceTypeInfo);
        }
        data.profileId = predefined.invoiceTypeInfo.profileId;
        data.documentTypeCode = predefined.invoiceTypeInfo.documentTypeCode;
        data.accountingCost = predefined.invoiceTypeInfo.accountingCost;
        if (predefined.invoiceTypeInfo.retailCustomer) {
            data.retailCustomer = predefined.invoiceTypeInfo.retailCustomer;
        } else {
            if (predefined.invoiceTypeInfo.trdDocBelgeLines && predefined.invoiceTypeInfo.trdDocBelgeLines.length > 0) {
                data.trdDocBelgeLines = predefined.invoiceTypeInfo.trdDocBelgeLines;
            }
            data.retailCustomer = false;
        }

        data = self.predefinedBelgeType(data, predefined.invoiceTypeInfo);

        self.setState({data, isUpdateScenario: true, predefinedDocumentType: predefined}, () => this.getXSLT());
    }

    onChangeValue(e) {
        let data = deepCopyObject(this.state.data);
        const {name, value} = e;
        if (name === "retailCustomer") {
            if (value) {
                //data.externalCustomer = {};
                //data.externalCustomerAddress = {};
            } else {
                data.trdDocExternalCustomer = null;
            }
        }
        data[name] = (name === "paymentExchangeRate" ? (new Decimal(value)).toNumber() : value);
        this.setState({data});
    }

    setMediaViewer() {
        this.setState({url: null, mediaModal: false});
    }

    renderPredefinedButtons() {
        return (
            <CardBody style={{padding: '10px 15px 0'}}>
                {
                    predefinedInvoiceTypes.filter(defined => predefinedButtonFilter(defined, this.state.newPreDefined,"EBELGE")).map(predefined => {
                        return this.renderSinglePredefined(predefined)
                    })
                }
            </CardBody>
        );
    };

    renderSinglePredefined(predefined) {
        return <Button key={predefined.value} color="info" style={{padding: '4px 8px', margin: '1px 3px'}}
                       onClick={() => this.setPredefinedType(predefined,true)}>{predefined.label}</Button>;
    };

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    getSourceUrn() {
        let userAliasList = this.state.userAliasList;
        if (userAliasList && userAliasList.length > 0) {
            this.onChangeValue({name: "sourceUrn", value: userAliasList[0].workScopecode});
        }
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({activeTab: tab});
        }
    }

    setTouristInfo(touristInfo) {
        if (touristInfo) {
            let data = deepCopyObject(this.state.data);
            if (!data["trdDocBelgeTaxFree"])
                data["trdDocBelgeTaxFree"] = {};

            data["trdDocBelgeTaxFree"]["firstName"] = (touristInfo.hasOwnProperty("firstName") ? touristInfo["firstName"] : null);
            data["trdDocBelgeTaxFree"]["familyName"] = (touristInfo.hasOwnProperty("familyName") ? touristInfo["familyName"] : null);
            data["trdDocBelgeTaxFree"]["touristCity"] = (touristInfo.hasOwnProperty("touristCity") ? touristInfo["touristCity"] : null);
            data["trdDocBelgeTaxFree"]["touristCitySubdivision"] = (touristInfo.hasOwnProperty("touristCitySubdivision") ? touristInfo["touristCitySubdivision"] : null);
            data["trdDocBelgeTaxFree"]["touristCountry"] = (touristInfo.hasOwnProperty("touristCountry") ? touristInfo["touristCountry"] : null);
            data["trdDocBelgeTaxFree"]["touristNationality"] = (touristInfo.hasOwnProperty("touristNationality") ? touristInfo["touristNationality"] : null);
            data["trdDocBelgeTaxFree"]["touristPassportDate"] = (touristInfo.hasOwnProperty("touristPassportDate") ? touristInfo["touristPassportDate"] : null);
            data["trdDocBelgeTaxFree"]["touristPassportNo"] = (touristInfo.hasOwnProperty("touristPassportNo") ? touristInfo["touristPassportNo"] : null);
            this.setState({data});
        }
    }

    setDocExternalCustomer(docExternalCustomer) {
        let data = deepCopyObject(this.state.data);
        data["trdDocExternalCustomer"] = docExternalCustomer;
        this.setState({data});
    }

    setGocIdaresi(gocIdaresi, isGocIdaresi) {
        this.setExternalCustomer(gocIdaresi, gocIdaresi.externalCustomerAddressList[0]);
        let data = deepCopyObject(this.state.data);
        data["paymentFormattedName"] = gocIdaresi.formattedName;
        data["paymentVkn"] = gocIdaresi.vknTckn;
        data["paymentCity"] = gocIdaresi.externalCustomerAddressList[0].cityName;
        data["paymentCountry"] = gocIdaresi.externalCustomerAddressList[0].countryName;
        Alert.info("Ödeme Yapacak Alıcı bilgileri cari bilgilerinden kopyalanmıştır. Lütfen kontrol ediniz.", {
            position: 'top-right',
            effect: 'stackslide',
            timeout: 5000
        });
        this.setState({isGocIdaresi, data});
    }

    updateScenario(isUpdateScenario) {
        this.setState({isUpdateScenario});
    }

    getXSLT() {
        let xslts = this.state.xslts.filter(xslt => xslt.xsltType === "EARSIVBESBINOTUZBIN");
        let xslt = xslts.find(x => x.isDefault === 1);
        if (xslt) {
            this.onChangeValue({name: "xsltPath", value: (xslt.xsltFilepath)});
        } else {
            if (xslts && xslts instanceof Array && xslts.length > 0)
                this.onChangeValue({name: "xsltPath", value: (xslts[xslts.length - 1].xsltFilepath)});
            else
                this.onChangeValue({name: "xsltPath", value: null});
        }
    }

    filterXSLTs() {
        let self = this;
        return self.state.xslts
            .filter(xslt => (xslt.xsltType === "EARSIVBESBINOTUZBIN"))
            .map(xslt => ({
                value: xslt.xsltFilepath,
                label: xslt.xsltFilename
            }));
    }

    approveAsDespatch() {
        let approveAsDespatch = deepCopyObject(this.state.approveAsDespatch);
        let trdDocBelgeNotes = deepCopyObject(this.state.data.trdDocBelgeNotes);

        if (approveAsDespatch) {
            let found = false;
            let index;
            for (let i = 0; i < trdDocBelgeNotes.length; i++) {
                if (trdDocBelgeNotes[i].note === "İrsaliye yerine geçer.") {
                    found = true;
                    index = i;
                    break;
                }
            }

            if (trdDocBelgeNotes.length > 1) {
                trdDocBelgeNotes.splice(index, 1);
            } else {
                let init = {};
                trdDocBelgeNotes.splice(index, 1);
                init.note = "";
                init.recordId = null;
                trdDocBelgeNotes.push(init);
            }

        } else {
            if (trdDocBelgeNotes.length > 0) {
                let added = false;
                for (let i = 0; i < trdDocBelgeNotes.length; i++) {
                    if ((trdDocBelgeNotes[i].note === "" || trdDocBelgeNotes[i].note === null) && trdDocBelgeNotes[i].recordId === null) {
                        trdDocBelgeNotes[i].note = "İrsaliye yerine geçer.";
                        added = true;
                        break;
                    }
                }
                if (!added) {
                    let newNote = {};
                    newNote.note = "İrsaliye yerine geçer.";
                    trdDocBelgeNotes.push(newNote);
                }
            }
        }

        this.setState({
            data: {
                ...this.state.data,
                trdDocBelgeNotes,
            },
            approveAsDespatch: !approveAsDespatch
        })
    }

    setTrdDocBelgeLines(trdDocBelgeLines, medulaData, externalCustomer, externalCustomerAddress) {
        let data = deepCopyObject(this.state.data);
        data['trdDocBelgeLines'] = trdDocBelgeLines;
        data = CreateEditBelge.calculateTotal(data, this.state.isFree);
        if (externalCustomer !== undefined && externalCustomerAddress !== undefined) {
            data["payableAmount"] = medulaData.totalNetAmount;
        }
        if (medulaData && medulaData.type && medulaData.type === "cezaeviEczanem") {
            data["payableAmount"] = medulaData.totalPayablePrice;
        }

        if (data.tmpDocBelgeBrokerCosts !== null && ((data.profileId === "HKS" && data.documentTypeCode === "KOMISYONCU") || data.documentTypeCode === "HKSKOMISYONCU")) {
            if(data.tmpDocBelgeBrokerCosts.calculateFromPercent) {
                let method= ((data.tmpDocBelgeBrokerCosts.isTaxInclusive===null) || (data.tmpDocBelgeBrokerCosts.isTaxInclusive===true)) ? 'taxInclusiveAmount' : 'taxExclusiveAmount'
                data.tmpDocBelgeBrokerCosts = this.calculateCost(data[method]);
            }
            let totalCosts = this.calculateTotalCosts(data.tmpDocBelgeBrokerCosts);
            data['payableAmount'] = new Decimal(data['taxInclusiveAmount']).toNumber() - new Decimal(totalCosts).toNumber();
        }

        if (medulaData) {
            this.setState({data, manual: true},()=>this.updatePeriodList(data));
        } else {
            this.setState({data});
        }
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let result = validateField(rule, boundary, e.target.value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        this.setState({error});
    }

    isKamu() {
        const {data} = this.state;
        const {externalCustomerAddress, profileId} = data;

        if (!!externalCustomerAddress) {
            if (profileId === 'KAMU' ||
                ("urn:mail:defaultpk@muhasebat.gov.tr" === externalCustomerAddress.postboxAlias &&
                    (!!profileId && (profileId === 'TEMELFATURA' || profileId === 'TICARIFATURA')))) {
                return true;
            }
        }
        return false;
    }

    setTrdDocBelgeNotes(trdDocBelgeNotes) {
        let data = deepCopyObject(this.state.data);
        data['trdDocBelgeNotes'] = trdDocBelgeNotes;
        this.setState({data});
    }

    changeKDV(name, value) {
        let data = deepCopyObject(this.state.data);
        data[name] = value;
        this.setState({data});
    }

    onIsFree(e) {
        let data = deepCopyObject(this.state.data);
        let checked = e.target.checked;
        if (checked && data.profileId === "IHRACAT") {
            data.payableAmount = 0.00;
        } else {
            data = CreateEditBelge.calculateTotal(data, checked);
        }
        this.setState({data: data, isFree: checked});
    }

    setTrdDocBelgeDespatchReferences(trdDocBelgeDespatchReferences) {
        let data = deepCopyObject(this.state.data);
        data['trdDocBelgeDespatchReferences'] = trdDocBelgeDespatchReferences;
        this.setState({data});
    }

    setTrdDocIadeTable(iadeTables) {
        let data = deepCopyObject(this.state.data);
        data['iadeTables'] = iadeTables;
        this.setState({data});
    }

    checkSaveButtonIsPassive() {
        let perm = !hasUserRight(UserRightsEnum.besbinotuzbin.create, this.props.currentUser);
        if (this.state.saveLoading || !hasUserRight(UserRightsEnum.besbinotuzbin.create, this.props.currentUser)) {
            return true;
        } else if ((this.state.userAliases && this.state.userAliases.length === 0) ||
            (VirtualHost.conf.resourcePrefix === "faturam24" && moment() <= moment(this.state.userAliases[0].processStartDate).add(7, 'days'))) {
            return false;
        } else if (!this.state.userAliasList || this.state.userAliasList.length === 0) {
            return true;
        }
        return false;
    }

    onChangeDate(momentObj, name) {
        let data = deepCopyObject(this.state.data);
        if (!(typeof momentObj === "string")) {
            if (name === "date") {
                let date = momentObj.format("YYYY-MM-DD");
                let time = moment(data.issueDate).format("HH:mm:ss");
                data.issueDate = moment(date + "T" + time).format("YYYY-MM-DDTHH:mm:ss");
                this.setState({data});
            } else if (name === "time") {
                let time = momentObj.format("HH:mm:ss");
                let date = moment(data.issueDate).format("YYYY-MM-DD");
                data.issueDate = moment(date + "T" + time).format("YYYY-MM-DDTHH:mm:ss");
                this.setState({data});

            } else {

            }
        } else {

        }
    }

    async onChangeDateAndCurrency  (momentObj, name, currencyCode, forexType)  {
        await this.onChangeDate(momentObj, name);
        this.onChangeCurrency(currencyCode ? {value: currencyCode} : {value: "TRY"}, forexType && forexType === "Satış" ? "ForexSelling" :  "ForexBuying");
    }

    onChangeCurrency(e, label) {
        let data = deepCopyObject(this.state.data);
        data["documentCurrencyCode"] = e.value;
        if (data["documentCurrencyCode"] === "TRY") {
            this.setState({data});
            return;
        }

        let issueDate = moment(this.state.data.issueDate).format("YYYY-MM-DD");
        let options = {
            code: e.value,
            date: issueDate
        };

        let self = this;
        let params = {
            url: `/common/getCurrencyValue/${options.code}/${options.date}`,
            method: "post",
        };

        request(params)
            .then(response => {
                let forex = response.data;
                data['paymentExchangeRate'] = forex[label];
                self.setState({
                    forex: forex,
                    data: data,
                    suffix: (self.state.currencyCodes).find(x => x.shortCode === data['documentCurrencyCode']).symbol
                });
            }).catch(function (error) {
            let forex = {ForexSelling: "0.00", ForexBuying: "0.00"};
            data['paymentExchangeRate'] = forex[label];
            self.setState({
                forex: forex,
                data: data,
                suffix: (self.state.currencyCodes).find(x => x.shortCode === data['documentCurrencyCode']).symbol
            });
            showAxiosError(error);
        });
    }

    onChange(e, label) {
        if (label === "ForexBuying") {
            this.setState({forexType: "Alış"});
        } else {
            this.setState({forexType: "Satış"});
        }

        let data = deepCopyObject(this.state.data);
        if (data.forex === undefined || data.forex[label] === undefined) {
            this.onChangeCurrency({value: data.documentCurrencyCode}, label);
        } else {
            data['paymentExchangeRate'] = this.state.forex[label];
            this.setState({data});
        }
    }


    fetchPredefinedInvoiceForUser(){
        let self = this;
        let params = {
            url: `/customer/fetchPredefinedInvoiceTypes`,
            method: 'post',
        };
        request(params)
            .then(function (response) {
                let newPreDefined = response.data;
                self.setState({newPreDefined})
            });
    }

    render() {
        if (!this.state.data)
            return (<ReactLoadingTop style={{width: "90px", height: "90px"}}/>);
        return (
            <div className="row baseBackground">
                {this.state.alert}
                {!this.state.data.deletedAt &&
                <NavBarKS offsetWidth={this.props.offsetWidth} innerWidth={window.innerWidth}
                          name={"createEditBelge"}>

                    <StickButton position="leftSide"
                                 title="Yeni"
                                 label={this.state.saveType === "new" && this.state.saveLoading ? "Oluşturuluyor..." : "Yeni"}
                                 disabled={this.checkSaveButtonIsPassive()}
                                 className="stickButton plus-circle"
                                 onClick={(e) => this.onClickSave(e, "new")}
                                 icon="plus-circle"/>

                    <StickButton position="leftSide"
                                 title="Goster"
                                 label={this.state.saveType === "Goster" && this.state.saveLoading ? "Oluşturuluyor..." : "Fatura Göster"}
                                 disabled={this.state.saveLoading || !hasUserRight(UserRightsEnum.besbinotuzbin.view, this.props.currentUser)}
                                 className="stickButton observe"
                                 onClick={(e) => this.onClickSave(e, "look")}
                                 icon="observe"/>

                    <StickButton position="rightSide"
                                 title="Kaydet"
                                 label={this.state.saveType === "save" && this.state.saveLoading ? "Kaydediliyor..." : "Kaydet"}
                                 disabled={this.checkSaveButtonIsPassive()}
                                 className="stickButton save"
                                 onClick={(e) => this.onClickSave(e, "save")}
                                 icon="save"/>

                    <StickButton position="rightSide"
                                 title="Kaydet & Kapat"
                                 label={this.state.saveType === "saveClose" && this.state.saveLoading ? "Kaydediliyor..." : "Kaydet & Kapat"}
                                 disabled={this.checkSaveButtonIsPassive()}
                                 className="stickButton terminate"
                                 onClick={(e) => this.onClickSave(e, "saveClose")}
                                 icon="terminate"/>
                </NavBarKS>
                }

                {this.state.mediaModal &&
                <MediaViewer modal={this.state.mediaModal}
                             url={this.state.url}
                             title={this.state.title}
                             listener={this.setMediaViewer}
                />
                }

                <div className="col-sm-12 satirBasi">
                    {showPredefinedBtn24(EntegratorConf.identifier) && this.state.newPreDefined !== null &&
                    <Card style={{marginTop: '10px'}}>
                        <div style={{padding: '5px 15px'}}>
                            <CardSubtitle style={{margin: 0}}>Öntanımlı Fatura Tİplerİ</CardSubtitle>
                        </div>

                        <div style={{padding: '12px 0 10px'}}>
                            {this.renderPredefinedButtons()}
                        </div>
                    </Card>
                    }
                    <div className="">
                        <div className="headerTextStyle ettn" style={{fontSize: '0.9em'}}>
                            <div className="row" style={{paddingLeft: "20px"}}>
                                <div className="col-sm-6 col-lg-6 row" style={{paddingTop: '4px'}}> ETTN
                                    : {this.state.data.documentUuid}</div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="card-nav-tabs card-plain">
                            <div className="card-header card-header-danger">
                                <div className="nav-tabs-navigation">
                                    <div className="nav-tabs-wrapper">
                                        <ul className="nav tabBackground nav-tabs" data-tabs="tabs">
                                            <li className="nav-item">
                                                <a className={"nav-link " + (this.state.activeTab === 'temelbilgiler' ? 'active' : '')}
                                                   onClick={() => {
                                                       this.toggle('temelbilgiler');
                                                   }}
                                                   data-toggle="tab">Temel Bilgiler</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={"nav-link " + (this.state.activeTab === 'digerbilgiler' ? 'active' : '')}
                                                   onClick={() => {
                                                       this.toggle('digerbilgiler');
                                                   }}
                                                   data-toggle="tab">Diğer Bilgiler</a>
                                            </li>
                                        </ul>
                                        <hr></hr>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="tab-content">
                                    <div
                                        className={"tab-pane " + (this.state.activeTab === 'temelbilgiler' ? 'active' : '')}
                                        id="temelbilgiler">
                                        <div className="col-sm-12">
                                            <div className="row baseDashboard">
                                                <div className="col-sm-7">
                                                    <div className="card-header" style={{paddingBottom: "25px"}}>
                                                        <div className="row">
                                                            <div className="col-sm-6">
                                                                <h4 className="card-title"
                                                                    style={{display: "inline"}}>{this.state.data.profileId === "YOLCUBERABERFATURA" ? "Turist " : (this.state.data.profileId === "IHRACAT" ? "Yabancı Firma " : "Müşteri ")} Bilgileri</h4>
                                                            </div>
                                                            <div className="col-sm-6 row">
                                                                <div className="col-sm-4"></div>

                                                                <label className="col-sm-6 col-form-label"
                                                                       style={{whiteSpace: "nowrap"}}>Perakende Müşteri</label>
                                                                <div className="col-sm-2">
                                                                    <div className="form-group"
                                                                         style={{paddingTop: "5px"}}>
                                                                        <input type="checkbox"
                                                                               checked={this.state.data.retailCustomer}
                                                                               style={{float: "right"}}
                                                                               onChange={(e) => e && this.onChangeValue({
                                                                                   name: "retailCustomer",
                                                                                   value: e.target.checked
                                                                               })}/>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div className=" ">
                                                        <div className="card-body">
                                                            {(this.state.data.profileId !== "YOLCUBERABERFATURA" && this.state.data.profileId !== "IHRACAT" && !this.state.data.retailCustomer &&
                                                                (this.state.data.externalCustomer.recordId === null || (this.state.data.externalCustomer.externalCustomerMainType !== ExternalCustomerMainType.Foreign))) &&
                                                            (<ExternalCustomer title="Müşteri Bilgileri"
                                                                               listener={this.setExternalCustomer}
                                                                               listenerAsync={this.setExternalCustomerAsync}
                                                                               errorListener={this.errorListener}
                                                                               requiredTaxOffice={false}
                                                                               error={this.state.error}
                                                                               cities={this.state.cities}
                                                                               countries={this.state.countries}
                                                                               includeForeign={true}
                                                                               checkGibUser={false}
                                                                               // docType={this.state.data.profileId !== "EARSIVFATURA" ? "EFATURA" : "EARSIVFATURA"}
                                                                               documentTypeCode={this.state.data.documentTypeCode}
                                                                               externalCustomer={this.state.data.externalCustomer}
                                                                               externalCustomerAddress={this.state.data.externalCustomerAddress}
                                                                               setPredefinedType = {this.setPredefinedType}
                                                                               currentUser = {this.props.currentUser}
                                                            />)
                                                            }
                                                            {this.state.data.profileId === "YOLCUBERABERFATURA" &&
                                                            (<TouristInfo listener={this.setTouristInfo}
                                                                          errorListener={this.errorListener}
                                                                          countries={this.state.countries}
                                                                          touristInfo={this.state.data.trdDocBelgeTaxFree}
                                                                          error={this.state.error}/>)

                                                            }
                                                            {this.state.data.profileId === "IHRACAT" ||
                                                                (this.state.data && this.state.data.externalCustomer &&
                                                                    this.state.data.externalCustomer.externalCustomerMainType === ExternalCustomerMainType.Foreign) && (
                                                                <ForeignCompanyInfo
                                                                    listener={this.setExternalCustomer}
                                                                    errorListener={this.errorListener}
                                                                    error={this.state.error}
                                                                    includeForeign={true}
                                                                    cities={this.state.cities}
                                                                    countries={this.state.countries}
                                                                    externalCustomer={this.state.data.externalCustomer}
                                                                    externalCustomerAddress={this.state.data.externalCustomerAddress}/>)
                                                            }
                                                            {this.state.data.retailCustomer &&
                                                            <NoIdentifier
                                                                {...this.props}
                                                                isEBelge="true"
                                                                requiredTaxOffice={true}
                                                                docExternalCustomer={this.state.data.trdDocExternalCustomer}
                                                                listener={this.setDocExternalCustomer}
                                                                countries={this.state.countries}
                                                                cities={this.state.cities}
                                                            />
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr/>
                                                <div className="col-sm-5 row">
                                                    <div className="card-header">
                                                        <h4 className="card-title">Fatura Bilgileri</h4>
                                                    </div>
                                                    <div className="col-sm-12 row ">
                                                        <div className="card-body">
                                                            <InvoiceType listener={this.documentTypeListener}
                                                                         manual={this.state.manual}
                                                                         isManual={this.isManual}
                                                                         profileIds={this.state.profileIds}
                                                                         invoiceTypeCodes={[
                                                                             {shortName: "SATIS", longName: "Satış", type: "InvoiceTypeCode"},
                                                                             {shortName: "IADE", longName: "İade", type: "InvoiceTypeCode"},
                                                                             {shortName: "TEVKIFAT", longName: "Tevkifat", type: "InvoiceTypeCode"},
                                                                             {shortName: "ISTISNA", longName: "İstisna", type: "InvoiceTypeCode"},
                                                                             {shortName: "OZELMATRAH", longName: "Özel Matrah", type: "InvoiceTypeCode"},
                                                                             {shortName: "IHRACKAYITLI", longName: "İhrac Kayıtlı", type: "InvoiceTypeCode"}
                                                                         ]}
                                                                         profileId="EBELGE"
                                                                         invoiceTypeCode={this.state.data.documentTypeCode}
                                                                         accountingCost={this.state.data.accountingCost}
                                                                         accountingCosts={this.state.accountingCosts}
                                                                         gocIdaresi={this.setGocIdaresi}
                                                                         isUpdateScenario={this.state.isUpdateScenario}
                                                                         updateScenario={this.updateScenario}
                                                            />

                                                            <div className="row">
                                                                <label className="col-sm-12 col-lg-6 col-form-label">Gönderim
                                                                    Şekli*</label>
                                                                <div className="col-sm-12 col-lg-6">
                                                                    <div
                                                                        className={"form-group" + this.validateClass('sendingType')}>
                                                                        <Select
                                                                            id="sendingType"
                                                                            clearable={false}
                                                                            placeholder="Seçiniz..."
                                                                            noResultsText="Kayıt bulunamadı."
                                                                            value={this.state.data.sendingType === null ? undefined : this.state.data.sendingType}
                                                                            onBlur={() => this.validateField({
                                                                                target: {
                                                                                    id: "sendingType",
                                                                                    dataset: {'vlength': "1,45"},
                                                                                    value: this.state.data.sendingType
                                                                                }
                                                                            })}
                                                                            options={[
                                                                                {
                                                                                    label: "Kağıt",
                                                                                    value: "KAGIT"
                                                                                },
                                                                                {
                                                                                    label: "Elektronik",
                                                                                    value: "ELEKTRONIK"
                                                                                }
                                                                            ]}
                                                                            onChange={(e) => e && this.onChangeValue({
                                                                                name: "sendingType",
                                                                                value: e.value
                                                                            })}
                                                                        />
                                                                        {this.validateMessage('sendingType') !== "" &&
                                                                        <UncontrolledTooltip placement="right"
                                                                                             target="sendingType"
                                                                                             delay={0}>
                                                                            {this.validateMessage("sendingType")}
                                                                        </UncontrolledTooltip>}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="row ">

                                                                <label className="col-sm-12 col-lg-6 col-form-label">Düzenlenme
                                                                    Tarihi *</label>
                                                                <div className="col-sm-12 col-lg-6">
                                                                    <div
                                                                        className={"form-group" + this.validateClass('issueDate')}>
                                                                        <Datetime locale="tr"
                                                                                  className="datepicker"
                                                                                  input={true}
                                                                                  inputProps={{id: 'issueDate'}}
                                                                                  closeOnSelect={true}
                                                                                  value={moment(this.state.data.issueDate)}
                                                                                  defaultValue={moment()}
                                                                                  dateFormat="DD-MM-YYYY"
                                                                                  timeFormat={false}
                                                                                  isValidDate={function (current) {
                                                                                      return current.isBefore(Datetime.moment());
                                                                                  }}
                                                                                  onChange={(e) =>
                                                                                      this.onChangeDateAndCurrency(e, "date",this.state.data.documentCurrencyCode,this.state.forexType)}/>
                                                                        {this.validateMessage('issueDate') !== "" &&
                                                                        <UncontrolledTooltip placement="right"
                                                                                             target="issueDate"
                                                                                             delay={0}>
                                                                            {this.validateMessage("issueDate")}
                                                                        </UncontrolledTooltip>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row ">

                                                                <label className="col-sm-12 col-lg-6 col-form-label">Düzenlenme
                                                                    Saati*</label>
                                                                <div className="col-sm-12 col-lg-6">
                                                                    <div
                                                                        className={"form-group" + this.validateClass('issueTime')}>
                                                                        <Datetime locale="tr"
                                                                                  className="timepicker"
                                                                                  inputProps={{id: 'issueTime'}}
                                                                                  input={true}
                                                                                  value={moment(this.state.data.issueDate)}
                                                                                  defaultValue={moment()}
                                                                                  dateFormat={false}
                                                                                  timeFormat={true}
                                                                                  onChange={(e) => this.onChangeDate(e, "time")}/>
                                                                        {this.validateMessage('issueTime') !== "" &&
                                                                        <UncontrolledTooltip placement="right"
                                                                                             target="issueTime"
                                                                                             delay={0}>
                                                                            {this.validateMessage("issueTime")}
                                                                        </UncontrolledTooltip>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <label className="col-sm-12 col-lg-6 col-form-label">Para
                                                                    Birimi*</label>
                                                                <div
                                                                    className={"col-sm-" + (this.state.data.documentCurrencyCode === "TRY" ? "12" : "12") + "  col-lg-" + (this.state.data.documentCurrencyCode === "TRY" ? "6" : "4")}>
                                                                    <div className="form-group">
                                                                        <Select
                                                                            id="documentCurrencyCode"
                                                                            clearable={false}
                                                                            placeholder="Seçiniz..."
                                                                            noResultsText="Kayıt bulunamadı."
                                                                            value={this.state.data.documentCurrencyCode === null ? this.onChangeCurrency({value: "TRY"}, "ForexBuying") : this.state.data.documentCurrencyCode}
                                                                            style={{width: "100%"}}
                                                                            onChange={(e) => this.onChangeCurrency({value: e.value}, "ForexBuying")}
                                                                            onBlur={() => this.validateField({
                                                                                target: {
                                                                                    id: "documentCurrencyCode",
                                                                                    dataset: {'vlength': "1,45"},
                                                                                    value: this.state.data.documentCurrencyCode
                                                                                }
                                                                            })}
                                                                            options={this.state.currencyCodes.map(currencyCode => ({
                                                                                value: currencyCode.shortCode,
                                                                                label: currencyCode.longCode
                                                                            }))}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                {
                                                                    this.state.data.documentCurrencyCode !== "TRY" &&
                                                                    <div className="col-sm-12 col-lg-2" style={{
                                                                        display: (this.state.data.documentCurrencyCode === "TRY" ? 'none' : ''),
                                                                        padding: '0px 0px 0px 1px'
                                                                    }}>
                                                                        <div className="dropdown">
                                                                            <button
                                                                                className="btn btn-secondary dropdown-toggle"
                                                                                type="button"
                                                                                style={{
                                                                                    margin: 0,
                                                                                    padding: "4px 9px"
                                                                                }}
                                                                                id="dropdownMenuButton"
                                                                                data-toggle="dropdown"
                                                                                aria-haspopup="true"
                                                                                aria-expanded="false">
                                                                                {this.state.forexType || "Alış"}
                                                                            </button>
                                                                            <div className="dropdown-menu"
                                                                                 aria-labelledby="dropdownMenuButton">
                                                                                <a className="dropdown-item"
                                                                                   onClick={(e) => this.onChange(e, "ForexBuying")}>Alış</a>
                                                                                <a className="dropdown-item"
                                                                                   onClick={(e) => this.onChange(e, "ForexSelling")}>Satış</a>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                            {
                                                                this.state.data.documentCurrencyCode !== "TRY" &&
                                                                <div className="row">
                                                                    <label
                                                                        className="col-sm-4 col-lg-6  col-form-label">Kur
                                                                        Değeri *</label>
                                                                    <div className="col-sm-8 col-lg-6">
                                                                        <div className="form-group">
                                                                            <NumberFormat
                                                                                value={this.state.data.paymentExchangeRate}
                                                                                allowNegative={false}
                                                                                isNumericString={true}
                                                                                thousandSeparator={'.'}
                                                                                decimalSeparator={','}
                                                                                suffix={this.state.suffix}
                                                                                displayType="input"
                                                                                isAllowed={values => {
                                                                                    return (values.value === "" ? false : true);
                                                                                }}
                                                                                placeholder="Kur Değeri"
                                                                                renderText={value => {
                                                                                    value.replace(/\./g, ',')
                                                                                }}
                                                                                onValueChange={(e) => this.onChangeValue({
                                                                                    name: 'paymentExchangeRate',
                                                                                    value: e.value
                                                                                })}
                                                                                className="form-control"/>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            }
                                                            <div className="row">
                                                                <label className="col-sm-4 col-lg-6 col-form-label">XSLT
                                                                    Dosyası:*</label>
                                                                <div className="col-sm-8 col-lg-6">
                                                                    <div
                                                                        className={"form-group" + this.validateClass('xsltPath')}>
                                                                        <Select
                                                                            name="xsltPath"
                                                                            value={this.state.data.xsltPath || this.getXSLT()}
                                                                            clearable={false}
                                                                            placeholder="Seçiniz..."
                                                                            noResultsText="Kayıt bulunamadı."
                                                                            onChange={(e) => e && this.onChangeValue({
                                                                                name: "xsltPath",
                                                                                value: e.value
                                                                            })}
                                                                            options={this.filterXSLTs()}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <br/>
                                                        <Row style={{
                                                            width: '100%',
                                                            marginTop: '15px',
                                                            paddingLeft: '10px'
                                                        }}>
                                                            <Col xs="2" style={{textAlign: 'center'}}>
                                                                <input type="checkbox"
                                                                       checked={this.state.approveAsDespatch}
                                                                       onChange={() => this.approveAsDespatch()}/>
                                                            </Col>

                                                            <Col xs="10">
                                                                <label>İrsaliye yerine geçer.</label>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={"tab-pane " + (this.state.activeTab === 'digerbilgiler' ? 'active' : '')} id="digerbilgiler">
                                        <div className="col-sm-12">
                                            <div className="row baseDashboard">
                                                <InformationPanel
                                                    key={"InformationPanel"}
                                                    manual={this.state.manual}
                                                    isKamu={this.isKamu}
                                                    isManual={this.isManual}
                                                    listenerOrderReference={this.setOrderReference}
                                                    listenerDespatchReferences={this.setTrdDocBelgeDespatchReferences}
                                                    listenerIadeTable={this.setTrdDocIadeTable}
                                                    listenerInternetSales={this.setTrdDocInvoiceInternetSales}
                                                    listenerCarrierParty={this.setTrdDocInvoiceCarrierParty}
                                                    listenertaxRepresentativeParty={this.setTrdDocInvoiceTaxRepresentativeParty}
                                                    listenerSGK={this.setSGKInfo}
                                                    listenerPayment={this.setPaymentInfo}
                                                    listenerClearPayment={this.clearPaymentInfo}
                                                    listenerCosts={()=>console.log("")}
                                                    despatchReferences={this.state.data.trdDocBelgeDespatchReferences}
                                                    iadeTables={this.state.data.iadeTables}
                                                    saleTypes={this.state.saleTypes}
                                                    cities={this.state.cities}
                                                    paymentMeansCodes={this.state.paymentMeansCodes}
                                                    paymentChannelCodes={this.state.paymentChannelCodes}
                                                    internetSales={(this.state.data.trdDocInvoiceInternetSales)}
                                                    orderReference={{
                                                        orderReferenceNumber: this.state.data.orderReferenceNumber,
                                                        orderReferenceDate: this.state.data.orderReferenceDate,
                                                        orderManager: this.state.data.orderManager
                                                    }}
                                                    errorListener={this.errorListener}
                                                    invoiceTypeCode={this.state.data.invoiceTypeCode}
                                                    profileId={this.state.data.profileId}
                                                    accountingCost={this.state.data.accountingCost}
                                                    paymentInfo={{
                                                        paymentChannelCode: this.state.data.paymentChannelCode,
                                                        paymentMeansCode: this.state.data.paymentMeansCode,
                                                        paymentFinancialAccountId: this.state.data.paymentFinancialAccountId,
                                                        instructionNote: this.state.data.instructionNote,
                                                        paymentFormattedName: this.state.data.paymentFormattedName,
                                                        paymentVkn: this.state.data.paymentVkn,
                                                        paymentCity: this.state.data.paymentCity,
                                                        paymentCountry: this.state.data.paymentCountry
                                                    }}
                                                    sgkInfo={{
                                                        sgkMukellefAdi: this.state.data.sgkMukellefAdi,
                                                        sgkMukellefKodu: this.state.data.sgkMukellefKodu,
                                                        sgkFileNo: this.state.data.sgkFileNo
                                                    }}
                                                    carrierParty={{
                                                        carrierPartyFamilyName: this.state.data.carrierPartyFamilyName,
                                                        carrierPartyFirstName: this.state.data.carrierPartyFirstName,
                                                        carrierPartyId: this.state.data.carrierPartyId,
                                                        carrierPartyName: this.state.data.carrierPartyName,
                                                        actualDeliveryDate: this.state.data.actualDeliveryDate
                                                    }}
                                                    taxRepresentativeParty={this.state.data.trdDocInvoiceTaxFree}
                                                    error={this.state.error}
                                                    activeTabListener={(activeTab) => this.setState({innerActiveTab: activeTab})}
                                                    activeTab={this.state.innerActiveTab}
                                                    documentId={this.props.match.params.recordId}
                                                    brokerCosts={this.state.data.tmpDocInvoiceBrokerCosts}
                                                    taxInclusiveAmount={this.state.data.taxInclusiveAmount}
                                                    taxExclusiveAmount={this.state.data.taxExclusiveAmount}
                                                    showOrderManagerLineNum={this.state.showOrderManagerLineNum}
                                                    externalCustomer={this.state.data.externalCustomer}
                                                    externalCustomerAddress={this.state.data.externalCustomerAddress}
                                                    documentTypeCode={this.state.data.documentTypeCode}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-12 baseDashboard" style={{marginTop: this.state.iade ? '10px' : '-5px'}}>
                        <BelgeLines listener={this.setTrdDocBelgeLines}
                                      manual={this.state.manual}
                                      isKamu={this.isKamu}
                                      isManual={this.isManual}
                                      errorListener={this.errorListener}
                                      isCreate={this.props.match.params.recordId === 0}
                                      error={this.state.error}
                                      suffix={this.state.suffix}
                                      trdDocBelgeLines={this.state.data.trdDocBelgeLines}
                                      profileId={this.state.data.profileId}
                                      accountingCost={this.state.data.accountingCost}
                                      documentTypeCode={this.state.data.documentTypeCode}
                                      withholdingTypes={this.state.withholdingTypes}
                                      charges={this.state.charges}
                                      unitCodes={this.state.unitCodes}
                                      currencyCodes={this.state.currencyCodes}
                                      exemptions={this.state.exemptions}
                                      countries={this.state.countries}
                                      documentCurrencyCode={this.state.data.documentCurrencyCode}
                                      packageTypeCodes={this.state.packageTypeCodes}
                                      deliveryTermsCodes={this.state.deliveryTermsCodes}
                                      transportMeansTypeCodes={this.state.transportMeansTypeCodes}
                                      transportModeCodes={this.state.transportModeCodes}
                                      classificationTypes={this.state.classificationTypes}
                                      gocIdaresi={this.setGocIdaresi}
                                      showOrderManagerLineNum={this.state.showOrderManagerLineNum}
                                      currentUser={this.props.currentUser}
                        />
                    </div>

                    <div className="col-sm-12" style={{marginTop: '10px'}}>
                        <div className="row baseDashboard">
                            <div className="col-sm-7">
                                <div className="card-header  ">
                                    <h4 className="card-title">Açıklama</h4>
                                </div>
                                <div className="card-body">
                                    <NoteList
                                        manual={this.state.manual}
                                        isManual={this.isManual}
                                        listener={this.setTrdDocBelgeNotes}
                                        errorListener={this.errorListener}
                                        error={this.state.error}
                                        rows={7}
                                        notes={this.state.data.trdDocBelgeNotes}/>
                                </div>
                            </div>
                            <hr></hr>
                            <div className="col-sm-5 row">
                                <div className="card-header">
                                    <h4 className="card-title">Toplamlar</h4>
                                </div>
                                <div className="col-sm-12">
                                    <div className="card-body">
                                        <TotalList suffix={this.state.suffix}
                                                   lines={this.state.data.trdDocBelgeLines}
                                                   totalKdv0Amount={this.state.data.totalKdv0Amount}
                                                   totalKdv1Amount={this.state.data.totalKdv1Amount}
                                                   totalKdv8Amount={this.state.data.totalKdv8Amount}
                                                   totalKdv10Amount={this.state.data.totalKdv10Amount}
                                                   totalKdv18Amount={this.state.data.totalKdv18Amount}
                                                   totalKdv20Amount={this.state.data.totalKdv20Amount}
                                                   isManual={this.state.data.isManual}
                                                   chargesName={"trdDocBelgeLineCharges"}
                                                   showKDV={true}
                                                   showATA={true}
                                                   type="invoice"
                                                   changeKDV={this.changeKDV}
                                                   lineExtensionAmount={this.state.data.lineExtensionAmount}
                                                   taxExclusiveAmount={this.state.data.taxExclusiveAmount}
                                                   taxInclusiveAmount={this.state.data.taxInclusiveAmount}
                                                   payableAmount={this.state.data.payableAmount}
                                                   totalCosts={this.state.totalCosts}
                                                   showTotalCosts={(this.state.data.profileId === "HKS" && this.state.data.documentTypeCode === "KOMISYONCU") || this.state.data.documentTypeCode === "HKSKOMISYONCU"}
                                                   isExport={(this.state.data.profileId === "IHRACAT")}
                                        />
                                        {this.state.data.profileId === "IHRACAT" &&
                                        <div className="row">
                                            <label className="col-sm-6 col-form-label">Bedelsiz İhracat</label>
                                            <div className="col-sm-6">
                                                <div className="form-group">
                                                    <input type="checkbox" checked={this.state.isFree}
                                                           onChange={this.onIsFree}/>
                                                </div>
                                            </div>
                                        </div>
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.saveLoading && <ReactLoadingTop style={{width: '90px', height: '90px'}}/>}
            </div>
        );
    }

}
export default CreateEditBelge;